import {handleAPI, API_VERSION_ONE_ADMIN} from '../../../utils/apiUtils';
const parent = 'SETTING_'

export function contactLensCleaningSolutionsLoad(filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/contact_lens_cleaning_solutions`;
  const method = 'GET'

  return {
    type: `${parent}CONTACT_LENS_CLEANING_SOLUTIONS_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function contactLensCleaningSolutionLoad(id, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/contact_lens_cleaning_solutions/${id}`;
  const method = 'GET'

  return {
    type: `${parent}CONTACT_LENS_CLEANING_SOLUTION_LOAD`,
    payload: handleAPI(url,filters,method)
  };
}

export function contactLensCleaningSolutionCreate(data, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/contact_lens_cleaning_solutions`;
  const method= 'POST'
  const { selected_store_ids, contact_lens_cleaning_solution_id, ...itemData } = data
  const body = selected_store_ids?.length && contact_lens_cleaning_solution_id
    ? { contact_lens_cleaning_solution_id, selected_store_ids }
    : { contact_lens_cleaning_solution: { ...itemData } }
  return {
    type: `${parent}CONTACT_LENS_CLEANING_SOLUTION_CREATE`,
    payload: handleAPI(url,filters,method, body)
  }
}

export function contactLensCleaningSolutionUpdate(data, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/contact_lens_cleaning_solutions/${data.id}`;
  const method = "PUT"
  return {
    type: `${parent}CONTACT_LENS_CLEANING_SOLUTION_UPDATE`,
    payload: handleAPI(url,filters,method, {contact_lens_cleaning_solution: {...data}})
  }
}

export function contactLensCleaningSolutionDelete(id, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/contact_lens_cleaning_solutions/${id}`;
  const method = 'DELETE';
  return {
    type: `${parent}CONTACT_LENS_CLEANING_SOLUTION_DELETE`,
    payload: new Promise((resolve, reject) => {
      handleAPI(url, filters, method)
        .then(response => {
          resolve({ id: id, ...response });
        })
        .catch(err => {
          reject(err);
        });
    })
  };
}

export function contactLensCleaningSolutionEdit(id) {
  return {
    type: `${parent}CONTACT_LENS_CLEANING_SOLUTION_EDIT`,
    id,
  };
}

export function contactLensCleaningSolutionEditCancel() {
  return {
    type: `${parent}CONTACT_LENS_CLEANING_SOLUTION_EDIT_CANCEL`
  };
}
